module.exports = __webpack_public_path__ + "static/metadata-aps-21eb04cf54f374acf487fce78e35b6f6.png";